import { initLenis } from './lib/lenis';
import { initPageLoader } from './modules/pageLoader';
import { initNav } from './modules/nav';
import { initWaveforms } from './modules/waveform';
import { initReveals } from './modules/reveals';
import { initHeroIntro } from './modules/heroIntro';
import { initHeroTiles } from './modules/heroTiles';
import { initParallax } from './modules/parallax';
import { initScrollMark } from './modules/scrollMark';
import { initStickyStack } from './modules/stickyStack';
import { initAnchors } from './modules/anchors';
import { initPricingToggle } from './modules/pricingToggle';
import { initAccordion } from './modules/accordion';
import { initVideoModal } from './modules/videoModal';
import { initArticleVideo } from './modules/articleVideo';
import { initReadingProgress } from './modules/readingProgress';
import { initComingSoon } from './modules/comingSoon';
import { initUnfiltered } from './modules/unfiltered';
import { initBio } from './modules/bio';
import { initHouseOfDjs } from './modules/houseOfDjs';
import { initDownloadGate } from './modules/downloadGate';
import { initSearchDemo } from './modules/searchDemo';

// Flip the CSS gate first: reveal/hide states only apply under `html.js`,
// so no-JS visitors always get a fully visible page.
document.documentElement.classList.add('js');

function safe(label: string, fn: () => void): void {
  try { fn(); } catch (err) { console.error(`[boot] ${label} failed`, err); }
}

function boot(): void {
  // Mount everything that can run silently while the loader is up. Each
  // module is wrapped so one broken module can't take down the boot sequence.
  safe('lenis',         initLenis);
  safe('nav',           initNav);
  safe('waveforms',     initWaveforms);
  safe('reveals',       initReveals);
  safe('parallax',      initParallax);
  safe('scrollMark',    initScrollMark);
  safe('stickyStack',   initStickyStack);
  safe('anchors',       initAnchors);
  safe('pricingToggle', initPricingToggle);
  safe('accordion',     initAccordion);
  safe('videoModal',    initVideoModal);
  safe('articleVideo',  initArticleVideo);
  safe('readingBar',    initReadingProgress);
  safe('comingSoon',    initComingSoon);
  safe('unfiltered',    initUnfiltered);
  safe('bio',           initBio);
  safe('houseOfDjs',    initHouseOfDjs);
  safe('downloadGate',  initDownloadGate);
  safe('searchDemo',    initSearchDemo);

  // Kick off the loader. The hero entrance fires the moment the loader
  // STARTS its lift — the two animations overlap so it feels like one
  // continuous reveal rather than "load → wait → animate".
  void initPageLoader({
    onDissolveStart: () => {
      safe('heroIntro', initHeroIntro);
      safe('heroTiles', initHeroTiles);
    },
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
